import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';



import DashBoard from './pages/Dashboard/DashBoard';
import Documents from './pages/Documents/Documents';

import SignIn from './pages/Auth/sign-in';
import ForgotPassword from './pages/Auth/forgot-password';
import ResetPassword from './pages/Auth/reset-password';

import Login_Otp from './pages/Auth/login-otp';
import Login_VerifyOtp from './pages/Auth/login-otp-verify';
import Login2fa from './pages/Auth/login-2fa';
import Setup2fa from './pages/Auth/setup-2fa';


import Chats from './pages/Chat/Chats';
import CompanyData from './pages/Companydata/CompanyData_ClientsList';
import CompanyDetails from './pages/Companydata/CompanyData';
import Profile from './pages/Profile/profile';


import BillingCustom from './pages/Billing';

import Default from './components/layouts/default';
import Auth from './components/layouts/auth';
import ProtectedRoutes from './utils/ProtectedRoutes';
import PublicRoutes from './utils/publicRoutes';
import DocumentsNew from './pages/Documents/DocumentsNew';
import TaskList from './pages/Chat/TaskList';
import FilePreview from './pages/Documents/FilePreview';
import Tasks from './pages/Tasks/tasks';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import Terms from './pages/Legal/Terms';
const App = () => {
  return (



<Router>
      <Routes>
       <Route  path="/" element={<ProtectedRoutes/>}>
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/chats" element={<Chats />} />
            <Route path="/CompanyData" element={<CompanyData/>} />
            <Route path="/CompanyData/:id" element={<CompanyDetails/>} />

            <Route path="/BillingCustom" element={<Default><BillingCustom/></Default>} />
          
            <Route path="/NewDocument/*" element={<DocumentsNew/>} />
            <Route path="/tasks" element={<Tasks/>}/>
            {/* Landing page for an attachment link in a chat email */}
            <Route path="/file-preview/:messageId/:fileId" element={<FilePreview/>} />
            <Route path="/file-preview/:messageId" element={<FilePreview/>} />
            <Route path="/profile" element={<Profile/>}/>
            <Route path="/setup-2fa" element={<Setup2fa/>}/>

        </Route>

         <Route element={<PublicRoutes/>}>
          <Route path="/login" element={<SignIn/>} />
          <Route path="/login-2fa" element={<Login2fa/>} />
          <Route path="/login-setup-2fa" element={<Setup2fa/>} />
         </Route>
        
        {/* Public legal pages, open with or without a login (SMS sender registration) */}
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms" element={<Terms/>} />

        <Route path="/forget-password" element={<ForgotPassword/>} />
        <Route path="/reset-password" element={<ResetPassword/>} />

        <Route path="/login-otp" element={<Login_Otp/>}/>
        <Route path="/login-VerifyOtp/:id" element={<Login_VerifyOtp/>}/>

      </Routes>
    </Router>



  )
}

export default App
